import React from 'react';
import Herosection from '../components/market/Herosection';
import Deliverables from '../components/market/Deliverables';
import Packages from '../components/market/Packages';
import Timeline from '../components/market/Timeline';
import Company from '../components/market/Company';
import CTA from '../components/market/CTA';

const Market = () => {
  return (
    <>
      <Herosection />
      <Deliverables />
      <Packages />
      <Timeline />
      <Company />
      <CTA />
    </>
  )
}

export default Market;